/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 * @description Alpha values to be used in CSS when concatenating a hex color with an opacity.
 *              E.g. background-color: `#ffccee${ALPHA_20}`
 */

export const ALPHA_100 = 'FF' as const
export const ALPHA_99 = 'FC' as const
export const ALPHA_98 = 'FA' as const
export const ALPHA_97 = 'F7' as const
export const ALPHA_96 = 'F5' as const
export const ALPHA_95 = 'F2' as const
export const ALPHA_94 = 'F0' as const
export const ALPHA_93 = 'ED' as const
export const ALPHA_92 = 'EB' as const
export const ALPHA_91 = 'E8' as const
export const ALPHA_90 = 'E6' as const
export const ALPHA_89 = 'E3' as const
export const ALPHA_88 = 'E0' as const
export const ALPHA_87 = 'DE' as const
export const ALPHA_86 = 'DB' as const
export const ALPHA_85 = 'D9' as const
export const ALPHA_84 = 'D6' as const
export const ALPHA_83 = 'D4' as const
export const ALPHA_82 = 'D1' as const
export const ALPHA_81 = 'CF' as const
export const ALPHA_80 = 'CC' as const
export const ALPHA_79 = 'C9' as const
export const ALPHA_78 = 'C7' as const
export const ALPHA_77 = 'C4' as const
export const ALPHA_76 = 'C2' as const
export const ALPHA_75 = 'BF' as const
export const ALPHA_74 = 'BD' as const
export const ALPHA_73 = 'BA' as const
export const ALPHA_72 = 'B8' as const
export const ALPHA_71 = 'B5' as const
export const ALPHA_70 = 'B3' as const
export const ALPHA_69 = 'B0' as const
export const ALPHA_68 = 'AD' as const
export const ALPHA_67 = 'AB' as const
export const ALPHA_66 = 'A8' as const
export const ALPHA_65 = 'A6' as const
export const ALPHA_64 = 'A3' as const
export const ALPHA_63 = 'A1' as const
export const ALPHA_62 = '9E' as const
export const ALPHA_61 = '9C' as const
export const ALPHA_60 = '99' as const
export const ALPHA_59 = '96' as const
export const ALPHA_58 = '94' as const
export const ALPHA_57 = '91' as const
export const ALPHA_56 = '8F' as const
export const ALPHA_55 = '8C' as const
export const ALPHA_54 = '8A' as const
export const ALPHA_53 = '87' as const
export const ALPHA_52 = '85' as const
export const ALPHA_51 = '82' as const
export const ALPHA_50 = '80' as const
export const ALPHA_49 = '7D' as const
export const ALPHA_48 = '7A' as const
export const ALPHA_47 = '78' as const
export const ALPHA_46 = '75' as const
export const ALPHA_45 = '73' as const
export const ALPHA_44 = '70' as const
export const ALPHA_43 = '6E' as const
export const ALPHA_42 = '6B' as const
export const ALPHA_41 = '69' as const
export const ALPHA_40 = '66' as const
export const ALPHA_39 = '63' as const
export const ALPHA_38 = '61' as const
export const ALPHA_37 = '5E' as const
export const ALPHA_36 = '5C' as const
export const ALPHA_35 = '59' as const
export const ALPHA_34 = '57' as const
export const ALPHA_33 = '54' as const
export const ALPHA_32 = '52' as const
export const ALPHA_31 = '4F' as const
export const ALPHA_30 = '4D' as const
export const ALPHA_29 = '4A' as const
export const ALPHA_28 = '47' as const
export const ALPHA_27 = '45' as const
export const ALPHA_26 = '42' as const
export const ALPHA_25 = '40' as const
export const ALPHA_24 = '3D' as const
export const ALPHA_23 = '3B' as const
export const ALPHA_22 = '38' as const
export const ALPHA_21 = '36' as const
export const ALPHA_20 = '33' as const
export const ALPHA_19 = '30' as const
export const ALPHA_18 = '2E' as const
export const ALPHA_17 = '2B' as const
export const ALPHA_16 = '29' as const
export const ALPHA_15 = '26' as const
export const ALPHA_14 = '24' as const
export const ALPHA_13 = '21' as const
export const ALPHA_12 = '1F' as const
export const ALPHA_11 = '1C' as const
export const ALPHA_10 = '1A' as const
export const ALPHA_9 = '17' as const
export const ALPHA_8 = '14' as const
export const ALPHA_7 = '12' as const
export const ALPHA_6 = '0F' as const
export const ALPHA_5 = '0D' as const
export const ALPHA_4 = '0A' as const
export const ALPHA_3 = '08' as const
export const ALPHA_2 = '05' as const
export const ALPHA_1 = '03' as const
export const ALPHA_0 = '00' as const
